import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: createBaseQuery('authentication', { timeout: 0 }),
  endpoints: builder => ({
    authorizeOAuth: builder.query({
      query: params => `/oauth?${toQueryParams(params)}`,
    }),
    getSSOUrl: builder.query({
      query: domain => `/sso?${toQueryParams({ domain })}`,
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useLazyGetSSOUrlQuery, useLazyAuthorizeOAuthQuery } = authenticationApi;
